export default {
  data() {
    return {
      props: {
        'name': 'BlogFeaturedComponent',
        'zIndex': 'auto',
        'paddingTop': '0px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px'
      },
      internal_config: {
        'width': '900px',
        'height': '500px',
        imageHeight: '200px',
        'zIndex': 'auto',
        'showDesktop': true,
        'showMobile': true,
        'paddingTop': '0px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',
        left: '0px',
        top: '0px',
        buttonPosition: 'left',
        backgroundColor: 'white',
        colorDetails: '#000',
        colorTexts: '#fff',
        colorSubTexts: '#000',
        readMoreText: 'Read More',
        dateFormat: 'YYYY-MM-DD',
        theme: 'simple',
        article: {
          id: 0,
          title: '',
          content: '',
          summary: '',
          scheduled_date: '',
          thumbnail: '',
          author: {
            name: ''
          },
          categories: []
        },
        showConfig: {
          showAuthor: true,
          showCategories: true,
          showThumbnail: true,
          showDate: true,
          showContent: true,
          showButton: true
        },
        titleStyle: {
          'family': 'Lato, sans-serif',
          'size': '25px',
          'sizeMobile': '15px',
          'color': 'black',
          'align': 'left',
          'weight': '400',
          'style': 'initial',
          'stroke': 'none'
        },
        contentStyle: {
          'family': 'Lato, sans-serif',
          'size': '25px',
          'sizeMobile': '15px',
          'color': 'black',
          'align': 'left',
          'weight': '400',
          'style': 'initial',
          'stroke': 'none',
          'height': '200px'
        }
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/editor/apps/Blog/Featured/Model.js